import { SliceFilters } from '@/services/MerchandisingCollectionsService';

export type FilterAction =
  | { type: 'reset' }
  | { type: 'brokenStock'; payload: SliceFilters['brokenStock'] }
  | { type: 'discount'; payload: SliceFilters['discount'] }
  | { type: 'price'; payload: SliceFilters['price'] }
  | { type: 'lowStock'; payload: SliceFilters['lowStock'] }
  | { type: 'releasePeriod'; payload: SliceFilters['releasePeriod'] };

export const productFiltersInitialState: SliceFilters = {
  brokenStock: {
    active: false,
  },
  discount: {
    type: 'ALL',
    range: {
      from: 0,
      to: 100,
    },
    active: false,
  },
  price: {
    range: {
      from: 0,
      to: 100,
    },
    active: false,
  },
  lowStock: {
    stockLimit: 10,
    active: false,
  },
  releasePeriod: {
    startsAt: new Date(new Date().setHours(0, 0, 0, 0)),
    endsAt: new Date(new Date().setHours(23, 59, 59, 999)),
    active: false,
  },
};

export function productFiltersReducer(
  state: SliceFilters,
  action: FilterAction,
): SliceFilters {
  switch (action.type) {
    case 'reset':
      return productFiltersInitialState;

    case 'brokenStock':
      return { ...state, brokenStock: { active: action.payload.active } };

    case 'discount':
      return {
        ...state,
        discount: {
          type: action.payload.type,
          range: action.payload.range,
          active: action.payload.active,
        },
      };

    case 'price':
      return {
        ...state,
        price: {
          range: action.payload.range,
          active: action.payload.active,
        },
      };

    case 'lowStock':
      return {
        ...state,
        lowStock: {
          stockLimit: action.payload.stockLimit,
          active: action.payload.active,
        },
      };

    case 'releasePeriod':
      return {
        ...state,
        releasePeriod: {
          startsAt: action.payload.startsAt,
          endsAt: action.payload.endsAt,
          active: action.payload.active,
        },
      };

    default:
      return state;
  }
}
